import { useState, useEffect } from 'react';

type WebViewDetection = {
  isWebView: boolean;
  isStandalone: boolean;
  detectedWebView: string | null;
  isPermissiveBrowser: boolean;
};

export function useWebViewDetection(): WebViewDetection {
  const [detection, setDetection] = useState<WebViewDetection>({
    isWebView: false,
    isStandalone: false,
    detectedWebView: null,
    isPermissiveBrowser: true,
  });

  useEffect(() => {
    const ua = navigator.userAgent || '';
    const isStandalone =
      window.matchMedia?.('(display-mode: standalone)').matches ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (navigator as any).standalone === true;

    const webViewPatterns: Array<{ pattern: RegExp; name: string }> = [
      { pattern: /FBAN|FBAV/i, name: 'Facebook' },
      { pattern: /Instagram/i, name: 'Instagram' },
      { pattern: /Line\//i, name: 'Line' },
      { pattern: /WhatsApp/i, name: 'WhatsApp' },
      { pattern: /Snapchat/i, name: 'Snapchat' },
      { pattern: /wv/i, name: 'WebView genérica' },
      { pattern: /WebView/i, name: 'WebView' },
    ];

    const isAndroid = /Android/i.test(ua);
    const isChrome = /Chrome\//i.test(ua);
    const isSamsungBrowser = /SamsungBrowser/i.test(ua);
    const hasVersion = /Version\//i.test(ua);
    const isGmailWebView = isAndroid && isChrome && !isSamsungBrowser && !hasVersion;

    let detectedWebView: string | null = null;
    let isWebView = false;

    if (isGmailWebView) {
      detectedWebView = 'Gmail';
      isWebView = true;
    } else {
      for (const { pattern, name } of webViewPatterns) {
        if (pattern.test(ua)) {
          detectedWebView = name;
          isWebView = true;
          break;
        }
      }
    }

    const isPermissiveBrowser = !isWebView;

    setDetection({
      isWebView,
      isStandalone,
      detectedWebView,
      isPermissiveBrowser,
    });
  }, []);

  return detection;
}
